import { useQuery } from "@tanstack/vue-query";
import DOMPurify from "dompurify";
import { computed, ref } from "vue";
import ordersService from "@/services/orders";
import type { OrderReminder } from "./types.ts";

export const useReminders = (orderId: string) => {
  const remindersQueryKey = computed(() => ["orderReminders", orderId]);

  const {
    data: reminders,
    isLoading: remindersLoading,
    error: remindersError,
  } = useQuery<OrderReminder[], Error>({
    enabled: () => Boolean(orderId),
    queryKey: remindersQueryKey.value,
    queryFn: async () => {
      const response = await ordersService.getOrderReminders(orderId);
      return (response.data?.data ?? []).map((reminder: OrderReminder) => ({
        ...reminder,
        body_html: DOMPurify.sanitize(reminder.body_html),
      }));
    },
  });
  return {
    reminders,
    remindersLoading,
    remindersError,
  };
};
